export default "__VITE_ASSET__LPimTJoG__"